import { ICorporate } from '../interface/corporate';
export class Corporate implements ICorporate  {
    constructor(
        public TAP_AUTOID : number,
        public CompanyName : string,
        public EmailExtension : string,
        public TotalAppt : number,
        public RemaningAppt : number,
        public CreateDate :Date,
        public IsActive : boolean
         ){
        
    }
}


// WEBPACK FOOTER //
// ./src/app/section/user/model/corporate.ts